import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const useStore = () => {
    // per modal
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);

    const [lightboxData, setLightboxData] = useState(null);

    const [lightboxIsOpen, setLightBoxIsOpen] = useState(false);
    useEffect(() => {
        if (!modalIsOpen) {
            setModalData(null);
        }
    }, [modalIsOpen]);
    return {
        modalIsOpen,
        openModal: () => setModalIsOpen(true),
        closeModal: () => setModalIsOpen(false),
        toggleOpenModal: () => setModalIsOpen((prev) => !prev),
        modalData,
        setModalData: (data) => setModalData(data),
        setLightboxData: (data) => setLightboxData(data),
        openLightbox: () => {
            setLightBoxIsOpen(true);
        },
        closeLightbox: () => {
            setLightBoxIsOpen(false);
        },
        lightboxData,
        lightboxIsOpen,
    };
};

const ModalContext = createContext({
    modalIsOpen: false,
    openModal: () => {},
    closeModal: () => {},
    openLightbox: () => {},
    closeLightbox: () => {},
    setLightboxData: () => {},
    lightboxIsOpen: false,
    lightboxData: null,
    toggleOpenModal: () => {},
    filterFunction: () => {},
    modalData: null,
    setModalData: ({
        onSubmitCallback,
        title,
        onSubmitEndpoint,
        formFields,
        selectedCrudObject,
        entity,
    }) => {},
});

export const ModalContextProvider = ({ children }) => (
    <ModalContext.Provider value={useStore()}>{children}</ModalContext.Provider>
);

ModalContextProvider.propTypes = {
    children: PropTypes.node,
};
export const useModalIsOpen = () => useContext(ModalContext).modalIsOpen;
export const useOpenModal = () => useContext(ModalContext).openModal;
export const useCloseModal = () => useContext(ModalContext).closeModal;
export const useToggleOpenModal = () =>
    useContext(ModalContext).toggleOpenModal;
export const useModalContext = () => useContext(ModalContext);
